import {LABEL_LIST_Grid_GET , LABEL_LIST_Grid_SUCCESS,LABEL_LIST_Grid_FAILURE } from './actions';

const initialState = {
    order: {}
}

export function LabelGridReducer(state = initialState, action) {
    if(action.type === LABEL_LIST_Grid_GET) {
        return state;
    }
    if(action.type === LABEL_LIST_Grid_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload,
                message: 'Success'
            }
        }
    }
    if(action.type === LABEL_LIST_Grid_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                message: action.payload
            }
        }
    }
    return state;
}

